import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";

const PhoneInputField = ({ value, onChange }) => {
  return (
    <div className="phone-field-wrapper">
      <PhoneInput
        country="eg"
        onlyCountries={["eg"]}
        disableDropdown={true}
        countryCodeEditable={false}
        value={value}
        onChange={(phone) => {
          if (!phone.startsWith("20")) {
            onChange("20");
          } else {
            onChange(phone);
          }
        }}
        inputClass="phone-input"
        buttonClass="phone-flag"
        containerClass="phone-container"
      />
    </div>
  );
};

export default PhoneInputField;
